import React from "react";
import SVG from "react-inlinesvg";

import Modal from '@app/components/ui/modals/Modal'
import leaveImage from '@src/images/landing/leave';

const StartModal = ({ modal, onStart, onCancel, starting }) => {
  return (
    <Modal ref={modal} className="start-main-tour-modal" closeButton={false}>
      <div className="start-main-tour-modal__inner">
        <div className="start-main-tour-modal__icon">
          <SVG src={leaveImage} />
        </div>
        <h2 className="start-main-tour-modal__header">
          Ready to Begin?
        </h2>
        <p className="start-main-tour-modal__hint">
          When you begin, you can't stop or pause. You have 60 minutes to finish the Olympiad.
        </p>
        <div className="modal-content__buttons w-flex-layout w-flex-layout--columns mb-0">
          <button
            className="btn btn--blue btn--md mb-0"
            onClick={onStart}
            disabled={starting}>
            {starting ? 'STARTING...' : 'START NOW'}
          </button>
          <button
            className="btn btn--light-blue btn--md"
            onClick={onCancel}
            disabled={starting}>
            CANCEL
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default StartModal;